import React, { useEffect, useRef, useState } from "react";

import logoFull from "../../assets/img/brands/trc-logo-white-red.svg"; // logo du header du site, gris → blanc, rouge TRC conservé
import teamPhoto from "../../assets/img/photos/login-team.jpg"; // équipe ambassadeurs (photo du Black Miles Challenge)

// Connexion pikachu (06/10/2026) : Google remplace le mot de passe, le code SMS reste la 2e étape.
// Client OAuth dédié « TRC pikachu » (distinct de celui du site public).
const GOOGLE_CLIENT_ID = "142050617111-ifmo6ve496cpo4k8odiknr377fs633ci.apps.googleusercontent.com";
const API = "https://back-api.therunningcollective.fr";
const CODE_LENGTH = 8;

const post = (path, body) =>
  fetch(API + path, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) })
    .then((r) => r.json())
    .catch(() => ({ message: "réseau" }));

let gisPromise = null;
function loadGoogleIdentity() {
  if (window.google && window.google.accounts && window.google.accounts.id) return Promise.resolve(window.google);
  if (!gisPromise) {
    gisPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://accounts.google.com/gsi/client";
      s.async = true;
      s.onload = () => resolve(window.google);
      s.onerror = () => { gisPromise = null; reject(new Error("gsi")); };
      document.head.appendChild(s);
    });
  }
  return gisPromise;
}

const CSS = `
.pk-login{position:fixed;inset:0;z-index:2000;display:grid;grid-template-columns:minmax(0,1.1fr) minmax(0,1fr);background:#f4f4f2;font-family:Inter,"Helvetica Neue",Arial,sans-serif;color:#111}
.pk-hero{position:relative;overflow:hidden;background:#0d0d0d center 45%/cover no-repeat;color:#fff;padding:48px 56px;display:flex;flex-direction:column;align-items:center;justify-content:center}
.pk-hero:before{content:"";position:absolute;inset:0;background:linear-gradient(180deg,rgba(0,0,0,.55) 0%,rgba(0,0,0,.05) 35%,rgba(0,0,0,.25) 60%,rgba(0,0,0,.88) 100%)}
.pk-hero:after{content:"";position:absolute;width:520px;height:520px;left:-200px;bottom:-260px;border-radius:50%;background:radial-gradient(circle,rgba(227,6,19,.45),rgba(227,6,19,0) 65%)}
.pk-hero>*{position:relative;z-index:1}
.pk-logo{width:min(380px,70%);height:auto;filter:drop-shadow(0 6px 24px rgba(0,0,0,.45))}
.pk-foot{position:absolute;left:0;right:0;bottom:32px;text-align:center;color:rgba(255,255,255,.55);font-size:12px;letter-spacing:.06em}
.pk-pane{display:flex;align-items:center;justify-content:center;padding:32px 20px}
.pk-card{width:100%;max-width:400px;background:#fff;border-radius:20px;padding:40px 36px;box-shadow:0 30px 80px -40px rgba(0,0,0,.35),0 0 0 1px rgba(0,0,0,.04)}
.pk-steps{display:flex;gap:8px;margin-bottom:28px}
.pk-steps span{height:4px;flex:1;border-radius:4px;background:#ececec;transition:background .3s}
.pk-steps span.on{background:#111}
.pk-kicker{font-size:11px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:#e30613;margin:0 0 8px}
.pk-title{font-size:28px;font-weight:800;letter-spacing:-.01em;margin:0 0 8px}
.pk-text{color:#666;font-size:14.5px;line-height:1.55;margin:0 0 28px}
.pk-google{display:flex;justify-content:center;min-height:44px}
.pk-note{display:flex;gap:10px;align-items:flex-start;margin-top:26px;padding:12px 14px;border-radius:12px;background:#f6f6f4;color:#555;font-size:12.5px;line-height:1.45}
.pk-note svg{flex:none;margin-top:1px}
.pk-err{margin-top:18px;padding:11px 14px;border-radius:12px;background:#fdecec;color:#a50e15;font-size:13.5px;line-height:1.45}
.pk-loading{margin-top:18px;color:#666;font-size:13.5px;display:flex;align-items:center;gap:10px;justify-content:center}
.pk-spin{width:16px;height:16px;border-radius:50%;border:2px solid #ddd;border-top-color:#111;animation:pkspin .8s linear infinite}
@keyframes pkspin{to{transform:rotate(360deg)}}
.pk-code{position:relative;margin-bottom:22px}
.pk-code input{position:absolute;inset:0;width:100%;height:100%;opacity:0;font-size:16px;border:0}
.pk-boxes{display:grid;grid-template-columns:repeat(8,1fr);gap:7px;pointer-events:none}
.pk-boxes div{height:52px;border-radius:12px;border:1.5px solid #e2e2e2;display:flex;align-items:center;justify-content:center;font-size:22px;font-weight:700;font-variant-numeric:tabular-nums;background:#fafafa;transition:border-color .15s,background .15s}
.pk-boxes div.cur{border-color:#111;background:#fff}
.pk-boxes div.full{background:#fff;border-color:#bdbdbd}
.pk-code.bad .pk-boxes div{border-color:#e30613}
.pk-btn{width:100%;height:50px;border:0;border-radius:999px;background:#111;color:#fff;font-weight:700;font-size:15px;cursor:pointer;transition:transform .1s,opacity .2s}
.pk-btn:disabled{opacity:.35;cursor:default}
.pk-btn:not(:disabled):active{transform:scale(.98)}
.pk-back{display:block;margin:18px auto 0;background:none;border:0;color:#777;font-size:13px;cursor:pointer;text-decoration:underline;text-underline-offset:3px}
@media (max-width:900px){.pk-login{grid-template-columns:1fr;grid-template-rows:auto 1fr;overflow:auto}.pk-hero{padding:28px 22px;min-height:240px}.pk-logo{width:min(260px,70%)}.pk-foot{display:none}.pk-card{padding:32px 22px}.pk-boxes{gap:5px}.pk-boxes div{height:46px;font-size:19px}}
`;

const Lock = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
);

function SignIn({ setToken }) {
  const [step, setStep] = useState("google"); // google | code
  const [login, setLogin] = useState("");
  const [requestID, setRequestID] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const googleRef = useRef(null);
  const codeRef = useRef(null);

  // Étape 1 : bouton Google officiel ; l'API vérifie le jeton et envoie le code par SMS.
  useEffect(() => {
    if (step !== "google") return;
    let cancelled = false;
    loadGoogleIdentity().then((google) => {
      if (cancelled || !googleRef.current) return;
      google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        ux_mode: "popup",
        auto_select: false,
        callback: async (response) => {
          if (!response || !response.credential) return;
          setLoading(true);
          setError("");
          const res = await post("/login-google", { credential: response.credential });
          setLoading(false);
          if (res.requestID && res.login) {
            setLogin(res.login);
            setRequestID(res.requestID);
            setCode("");
            setStep("code");
          } else if (String(res.message || "").includes("tentatives")) {
            setError("Trop de tentatives. Réessaie dans 15 minutes.");
          } else {
            setError("Ce compte Google n'a pas accès à pikachu. Utilise ton adresse @therunningcollective.fr.");
          }
        },
      });
      googleRef.current.innerHTML = "";
      google.accounts.id.renderButton(googleRef.current, { theme: "filled_black", size: "large", text: "continue_with", shape: "pill", width: 300, locale: "fr" });
    }).catch(() => setError("Le bouton Google n'a pas pu être chargé. Recharge la page."));
    return () => { cancelled = true; };
  }, [step]);

  useEffect(() => {
    if (step === "code" && codeRef.current) codeRef.current.focus();
  }, [step]);

  const submitCode = async (value) => {
    if (value.length !== CODE_LENGTH || loading) return;
    setLoading(true);
    setError("");
    const res = await post("/diy-login", { login, diy: value, requestID });
    setLoading(false);
    // Session ouverte seulement si l'API renvoie un jeton (sinon : {error, message}).
    if (res && res.token) {
      setToken(res);
      return;
    }
    setCode("");
    setError(String(res.message || "").includes("tentatives")
      ? "Trop de tentatives. Recommence la connexion dans 15 minutes."
      : "Code incorrect ou expiré (5 minutes). Réessaie ou recommence la connexion.");
    if (codeRef.current) codeRef.current.focus();
  };

  const onCode = (e) => {
    const v = e.target.value.replace(/\D/g, "").slice(0, CODE_LENGTH);
    setCode(v);
    if (error) setError("");
    if (v.length === CODE_LENGTH) submitCode(v);
  };

  const restart = () => { setStep("google"); setCode(""); setError(""); setRequestID(""); };

  return (
    <div className="pk-login">
      <style>{CSS}</style>
      <section className="pk-hero" style={{ backgroundImage: `url(${teamPhoto})` }}>
        <img className="pk-logo" src={logoFull} alt="The Running Collective" />
        <div className="pk-foot">ACCÈS RÉSERVÉ À L'ÉQUIPE TRC</div>
      </section>

      <div className="pk-pane">
        <div className="pk-card">
          <div className="pk-steps"><span className="on" /><span className={step === "code" ? "on" : ""} /></div>

          {step === "google" ? (
            <>
              <p className="pk-kicker">Étape 1 sur 2</p>
              <h2 className="pk-title">Connexion</h2>
              <p className="pk-text">Connecte-toi avec ton compte Google TRC. Un code de vérification te sera ensuite envoyé par SMS.</p>
              <div ref={googleRef} className="pk-google" />
              {loading ? <div className="pk-loading"><span className="pk-spin" /> Envoi du code par SMS…</div> : null}
              {error ? <div className="pk-err">{error}</div> : null}
              <div className="pk-note"><Lock /><span>Double vérification : ton compte Google, puis un code envoyé sur ton téléphone. Aucun mot de passe.</span></div>
            </>
          ) : (
            <>
              <p className="pk-kicker">Étape 2 sur 2</p>
              <h2 className="pk-title">Code SMS</h2>
              <p className="pk-text">Saisis le code à {CODE_LENGTH} chiffres reçu par SMS. Il est valable 5 minutes.</p>
              <form onSubmit={(e) => { e.preventDefault(); submitCode(code); }}>
                <div className={`pk-code ${error ? "bad" : ""}`} onClick={() => codeRef.current && codeRef.current.focus()}>
                  <input ref={codeRef} value={code} onChange={onCode} inputMode="numeric" autoComplete="one-time-code" maxLength={CODE_LENGTH} aria-label="Code reçu par SMS" />
                  <div className="pk-boxes">
                    {Array.from({ length: CODE_LENGTH }).map((_, i) => (
                      <div key={i} className={i === code.length ? "cur" : i < code.length ? "full" : ""}>{code[i] || ""}</div>
                    ))}
                  </div>
                </div>
                <button type="submit" className="pk-btn" disabled={code.length !== CODE_LENGTH || loading}>
                  {loading ? "Vérification…" : "Valider"}
                </button>
              </form>
              {error ? <div className="pk-err">{error}</div> : null}
              <button type="button" className="pk-back" onClick={restart}>Recommencer avec Google</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default SignIn;
